const memberDetail = {}
const qrCode = ''
const cancelTypeOptions = []
const memberCarAttribution = []
const myItemDataList = []
const storedValueRecordData = []
const myItemTotalRecord = 0
const storedValueRecord = 0
const memberCarBrandOptions = []
const memberCarTypeNameOptions = []
const maritalStatus = []
const occupation = []
const hobby = []
const vehicleUse = []

export default {
  storedValueRecord,
  storedValueRecordData,
  myItemTotalRecord,
  memberDetail,
  qrCode,
  cancelTypeOptions,
  myItemDataList,
  memberCarAttribution,
  memberCarBrandOptions,
  memberCarTypeNameOptions,
  maritalStatus,
  occupation,
  hobby,
  vehicleUse
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/store/state.js